import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import CreatableSelect from "react-select/creatable";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";

export const AVAILABLE_PROJECTION_VERSIONS_QUERY = '{ availableProjectionVersions { version } }';

const VersionSelect = ({version, setVersion, restrictToAvailableVersions, isDisabled}) => {
    const [options, setOptions] = useState(undefined);

    useEffect(() => {
        makeApolloClientCall(AVAILABLE_PROJECTION_VERSIONS_QUERY)
            .then((data) => {
                const versions = data?.availableProjectionVersions?.map((entry) => entry.version) || [];
                setOptions(versions.map((value) => ({label: value, value})));
            })
            .catch(() => setOptions([]));
    }, []);

    const value = version ? {label: version, value: version} : null;

    return (
        <div className={"id-input"} data-testid={"version-select"}>
            <span className='input-group-label' data-testid={'version-label'}>Version:</span>
            <CreatableSelect
                id={"version_dropdown"}
                className={"select-dropdown"}
                classNamePrefix={"select-dropdown"}
                options={options || []}
                value={value}
                isLoading={options === undefined}
                isClearable={true}
                isDisabled={isDisabled}
                placeholder={restrictToAvailableVersions ? "Select a version..." : "Select or create a version..."}
                isValidNewOption={restrictToAvailableVersions ? () => false : undefined}
                onChange={(option) => setVersion(option ? option.value : "")}
                onCreateOption={(input) => setVersion(input.trim())}
            />
        </div>
    );
};

VersionSelect.propTypes = {
    version: PropTypes.string,
    setVersion: PropTypes.func.isRequired,
    restrictToAvailableVersions: PropTypes.bool,
    isDisabled: PropTypes.bool
};

export default VersionSelect;
